import React, { useEffect, useState } from "react";
import { Drawer, Button as AntdButton, Divider, List, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import DataRow from "./DataRow";
import {
  createClass,
  deleteClass,
  getAllClasses,
  updateClass,
} from "services/quickbook.service";
import ClassAddEditDrawer from "./ClassAddEditDrawer";

export default function ClassIntegrationDrawer({ visible, onClose }) {
  //states start
  const [data, setData] = useState([]);
  const [showAddEditModal, setShowAddEditModal] = useState();
  //states end

  // non-data hooks start
  const dispatch = useDispatch();
  // non-data hooks end

  // use effect starts
  const loadData = async () => {
    const result = await dispatch(getAllClasses());
    if (result?.status === "success") {
      setData(result?.data);
    }
  };
  useEffect(() => {
    if (visible) loadData();
  }, [visible]);
  // use effects end

  // functions start
  const handleAdd = (values) => {
    dispatch(createClass(values)).then((result) => {
      if (result?.status === "success") {
        setShowAddEditModal(false);
        loadData();
        // loadData();
      }
    });
  };
  const handleUpdate = (id, values) => {
    dispatch(updateClass(id, values)).then((result) => {
      if (result?.status === "success") {
        setShowAddEditModal(false);
        loadData();
      }
    });
  };
  const handleDelete = (id) => {
    dispatch(deleteClass(id)).then((result) => {
      if (result?.status === "success") {
        loadData();
      }
    });
  };
  const deleteConfirmation = (id) => ({
    title: "Delete Class",
    content: <>Are you sure that you want to delete the class?</>,
    centered: true,
    maskClosable: true,
    onOk: (close) => {
      handleDelete(id);
      close();
    },
  });
  // functions end

  return (
    <Drawer
      destroyOnClose
      headerStyle={{ border: "none" }}
      className="integrationDrawer"
      width={"min(100vw, 420px)"}
      title={
        <div className="integrationDrawerTitle">
          <p>Class</p>
          <CloseOutlined onClick={onClose} />
        </div>
      }
      placement="right"
      onClose={onClose}
      visible={visible}
      closable={false}
    >
      <AntdButton
        className="integrationAddBtn"
        onClick={() => {
          setShowAddEditModal(true);
        }}
        type="text"
      >
        Add New
      </AntdButton>
      <Divider className="integrationDivider" />
      <List
        className="integrationList"
        itemLayout="vertical"
        size="large"
        dataSource={data?.filter?.((it) => it?.isActive)}
        renderItem={(record, index) => (
          <List.Item key={index}>
            <DataRow
              name={record.className}
              onEdit={() => {
                setShowAddEditModal(record);
              }}
              onDelete={() => {
                Modal.warning(deleteConfirmation(record.classId));
              }}
            />
          </List.Item>
        )}
      />
      <ClassAddEditDrawer
        visible={showAddEditModal}
        onClose={() => {
          setShowAddEditModal(false);
        }}
        data={showAddEditModal}
        onSuccess={(values) => {
          const isEdit = showAddEditModal?.classId !== undefined;
          if (isEdit) handleUpdate(showAddEditModal?.classId, values);
          else handleAdd(values);
        }}
      />
    </Drawer>
  );
}
